import React from 'react';

import { EmptyFieldValueRenderer } from '@/components/molecules/EmptyFieldValueRenderer';
import { FieldValue } from '@/components/molecules/FieldValue';
import { useTranslator } from '@/hooks/useTranslator';
import { BooleanField, ValueType } from '@/types/fields';

interface Props {
  readonly value: ValueType;
  readonly field: BooleanField<unknown>;
}
export const BooleanFieldValueRenderer: React.FC<Props> = (props: Props): React.ReactElement => {
  const { value } = props;

  const tr = useTranslator();
  const textRepresentation = React.useMemo(
    (): string => (value ? tr('YES') : tr('NO')),
    [tr, value],
  );

  if (typeof value !== 'boolean') {
    console.debug(`expected a boolean value, got: ${value}`);
    return <EmptyFieldValueRenderer />;
  }

  return <FieldValue value={textRepresentation} />;
};
